import { useCompaniesStore } from 'dashboard/stores/companies';
import types from 'dashboard/store/mutation-types';

// Companies uses Pinia while conversation permissions still live in Vuex.
export const installCompanyConversationAccess = (store, pinia) => {
  const companies = useCompaniesStore(pinia);
  return store.subscribe(({ type }) => {
    if (
      type === types.CLEAR_CONVERSATION_ACCESS ||
      type === types.REVOKE_CONVERSATION_ACCESS ||
      type === `contactConversations/${types.REVOKE_CONVERSATION_ACCESS}`
    ) {
      companies.clearCompanyConversations();
    }
  });
};
